import { useEffect, useState } from "react";

export function toPriceInput(n: number | null) {
  return n == null ? "" : String(n);
}

export function fromPriceInput(s: string): number | null {
  const trimmed = s.trim();
  if (!trimmed) return null;
  const n = Number(trimmed);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

type FieldsProps = {
  minStr: string;
  maxStr: string;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
  className?: string;
};

export function PriceFilterFields({
  minStr,
  maxStr,
  onMinChange,
  onMaxChange,
  className,
}: FieldsProps) {
  return (
    <div className={["poca-price", className].filter(Boolean).join(" ")}>
      <span className="poca-price__label">Price</span>
      <input
        className="poca-price__input"
        type="number"
        inputMode="numeric"
        min={0}
        placeholder="Min"
        value={minStr}
        onChange={(e) => onMinChange(e.target.value)}
        aria-label="Minimum price"
      />
      <span className="poca-price__sep">–</span>
      <input
        className="poca-price__input"
        type="number"
        inputMode="numeric"
        min={0}
        placeholder="Max"
        value={maxStr}
        onChange={(e) => onMaxChange(e.target.value)}
        aria-label="Maximum price"
      />
    </div>
  );
}

type Props = {
  min: number | null;
  max: number | null;
  onApply: (min: number | null, max: number | null) => void;
};

export function PriceFilter({ min, max, onApply }: Props) {
  const [minStr, setMinStr] = useState(toPriceInput(min));
  const [maxStr, setMaxStr] = useState(toPriceInput(max));

  useEffect(() => setMinStr(toPriceInput(min)), [min]);
  useEffect(() => setMaxStr(toPriceInput(max)), [max]);

  const apply = () => onApply(fromPriceInput(minStr), fromPriceInput(maxStr));
  const reset = () => {
    setMinStr("");
    setMaxStr("");
    onApply(null, null);
  };

  return (
    <form
      className="poca-price poca-price--toolbar"
      onSubmit={(e) => {
        e.preventDefault();
        apply();
      }}
    >
      <PriceFilterFields
        minStr={minStr}
        maxStr={maxStr}
        onMinChange={setMinStr}
        onMaxChange={setMaxStr}
      />
      <button type="submit" className="poca-price__btn">
        Apply
      </button>
      {(min != null || max != null) && (
        <button
          type="button"
          className="poca-price__btn poca-price__btn--ghost"
          onClick={reset}
        >
          Reset
        </button>
      )}
    </form>
  );
}
